import { Component, ViewChild, ViewContainerRef } from '@angular/core'
import { FieldWrapper, FormlyConfig, FormlyFieldConfig } from '@ngx-formly/core'
import { Subject } from 'rxjs'

@Component({
  selector: 'basin-custom-form-field',
  templateUrl: './custom-form-field.component.html',
  styleUrls: ['./custom-form-field.component.scss'],
})
export class CustomFormFieldComponent extends FieldWrapper {
  @ViewChild('fieldComponent', { read: ViewContainerRef, static: true })
  fieldComponent!: ViewContainerRef

  constructor(private formlyConfig: FormlyConfig) {
    super()
  }

  actionDescriptionClicked(event: Event) {
    const actionDescriptionClicked$ = this.props
      .actionDescriptionClicked as Subject<{
      field: FormlyFieldConfig
      event: Event
    }>
    actionDescriptionClicked$ &&
      actionDescriptionClicked$.next({ field: this.field, event })
  }

  get errors() {
    const errors = this.formControl.errors || {}

    return Object.keys(errors).map((key) => {
      const message = this.formlyConfig.getValidatorMessage(key)

      if (typeof message === 'function') {
        return {
          key: key,
          message: message(errors[key], this.field),
        }
      }
      return { key: key, message: message }
    })
  }

  get showError(): boolean {
    return this.options.showError(this)
  }
}
